import { render, staticRenderFns } from "./AbkNotAcceptedUsers.vue?vue&type=template&id=1a6ebd23&scoped=true&"
import script from "./AbkNotAcceptedUsers.vue?vue&type=script&lang=js&"
export * from "./AbkNotAcceptedUsers.vue?vue&type=script&lang=js&"
import style0 from "./AbkNotAcceptedUsers.vue?vue&type=style&index=0&id=1a6ebd23&scoped=true&lang=scss&"
import style1 from "./AbkNotAcceptedUsers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6ebd23",
  null
  
)

export default component.exports